import { Button, Stack, Typography } from '@mui/material'
import { SimplePageWrapper } from '../simple-page-wrapper/SimplePageWrapper'
import { Controller, Form } from 'react-hook-form'
import { StyledSelect } from '../form/StyledSelect'
import { getPhoneCountries } from '~/@utils/phone/getPhoneCountries'
import { StyledMenuItem } from '../form/StyledMenuItem'
import { FormStyledTextField } from '../form/FormStyledTextField'
import { Link } from 'react-router-dom'
import { Header } from '~/@ui/header/Header'

interface Props {
  title: string
  text: string
  onClickBack: () => void
  continueButtonLabel: string
  questionText: string
  linkLabel: string
  link: string
  control: any
  handleKeyDown: (event: React.KeyboardEvent) => void
  handleSubmitClick: () => void
  isStartLoading: boolean
}

export const PhoneInput = ({
  title,
  text,
  onClickBack,
  continueButtonLabel,
  questionText,
  linkLabel,
  link,
  control,
  handleKeyDown,
  handleSubmitClick,
  isStartLoading,
}: Props) => {
  const { countries, getCountryByCode } = getPhoneCountries()

  return (
    <SimplePageWrapper onClickBack={onClickBack}>
      <Stack className="h-full justify-between">
        <Stack>
          <Stack className="px-5">
            <Header title={title} text={text} className="pt-6" />

            <Form
              control={control}
              className="flex flex-row w-full gap-1d mt-8">
              <Controller
                name="phonePrefix"
                control={control}
                defaultValue="+421"
                render={({ field }) => (
                  <StyledSelect
                    {...field}
                    renderValue={(value: unknown): React.ReactNode => {
                      const selectedCountry = getCountryByCode(value as string)

                      if (!selectedCountry) return value as string

                      return (
                        <Stack className="flex-row items-center gap-2">
                          {selectedCountry.flag}
                          <Typography className="text-3d font-semibold text-zBlack200 tabular-nums">
                            {selectedCountry.code}
                          </Typography>
                        </Stack>
                      )
                    }}>
                    {countries.map(({ code, flag, name }) => (
                      <StyledMenuItem key={code} value={code}>
                        {flag}
                        <Typography className="text-3d font-semibold text-zBlack200 tabular-nums">
                          {code}
                        </Typography>
                        <Typography className="text-3d font-medium text-zGrey400">
                          {name}
                        </Typography>
                      </StyledMenuItem>
                    ))}
                  </StyledSelect>
                )}
              />

              <FormStyledTextField
                control={control}
                name="phoneNumber"
                formatNumber
                placeholder="Telefónne číslo"
                onKeyDown={handleKeyDown}
                inputMode="numeric"
                type="tel"
                slotProps={{
                  htmlInput: {
                    pattern: '[0-9]*',
                    maxLength: 15,
                  },
                }}
              />
            </Form>

            <Button
              onClick={handleSubmitClick}
              variant="contained"
              className="h-[56px] mt-6"
              disabled={isStartLoading}>
              <Typography className="text-3d font-medium text-zWhite200">
                {continueButtonLabel}
              </Typography>
            </Button>
          </Stack>
        </Stack>

        <Stack className="items-center pb-14">
          <Typography className="text-sm font-medium text-zGrey400">
            {questionText}
          </Typography>
          <Link to={link}>
            <Typography className="text-sm font-semibold text-zBlack200">
              {linkLabel}
            </Typography>
          </Link>
        </Stack>
      </Stack>
    </SimplePageWrapper>
  )
}
